<template>
  <div :id="componentId+'-plot_area'" class="row">
  </div>
</template>

<script>
/* eslint-disable */
import * as d3 from "d3";
import {loadingCircle} from "../mixins/D3Mixin";


export default {
  name: "SeasonalGraphWidget",
  props: ["plotData", "componentId", "advanced"],
  mixins: [loadingCircle],
  data() {
    return {
      divId: this.componentId + '-plot_area',
    }
  },

  watch: {
    plotData() {
      this.drawSeasonalPlot()
    },
  },

  mounted() {
    this.initSvg()
  },

  methods: {
    initSvg() {
      this.divElement = document.getElementById(this.divId)
      this.drawSeasonalPlot()
    },
    drawSeasonalPlot() {
      if (this.divElement.childNodes.length > 0) {
        while (this.divElement.firstChild) {
          this.divElement.removeChild(this.divElement.lastChild);
        }
      }
      // set the dimensions and margins of the graph
      if (this.divElement) {
        let margin = {top: 20, right: 20, bottom: 40, left: 40},
            width = 350 - margin.left - margin.right,
            height = 208 - margin.top - margin.bottom;
        if (this.plotData == null) {
          this.spinningCircle(margin, width, height)
        } else {
          if (this.plotData.data.length !== 0) {
            let css_col = "col-12"
            let legend = false
            let svg_numbers = this.plotData.data.length
            if (this.plotData.data.length >= 2) {
              css_col = "col-6"

            }
            if (this.advanced === "checked") {
              legend = true
            }
            let plotDataDomain = this.plotData.domain.ymax
            let divElement = this.divElement
            this.plotData.data.forEach(function (split, index) {
              let me = this
              const svgb = d3.select(divElement)
                  .append("svg")
                  .attr("class", css_col)
                  .attr("viewBox", `0 0 ${width + margin.left + margin.right} ${height + margin.top + margin.bottom}`)
                  .append("g")
                  .attr("transform",
                      "translate(" + margin.left + "," + margin.top + ")");


              let div = d3.select("body").append("div2")
                  .attr("class", "tooltip")
                  .style("opacity", 0);
              let group = [...new Set(split.values.map(d => d.subgroup))];
              // Compute quartiles, median, inter quantile range min and max --> these info are then used to draw the box.
              let sumstat = d3.rollup(split.values, function (d) {
                let q1 = d3.quantile(d.map(function (g) {
                  return g.values;
                }).sort(d3.ascending), .25)


                let median = d3.quantile(d.map(function (g) {
                  return g.values;
                }).sort(d3.ascending), .5)
                let q3 = d3.quantile(d.map(function (g) {
                  return g.values;
                }).sort(d3.ascending), .75)
                let interQuantileRange = q3 - q1
                let min = d3.min(d.map(function (g) {
                  return g.values;
                }))
                let max = d3.max(d.map(function (g) {
                  return g.values;
                }))
                // min = q1 - (1.5 * interQuantileRange)
                // max = q3 + (1.5 * interQuantileRange)
                return ({

                  q1: q1,
                  median: median,
                  q3: q3,
                  interQuantileRange: interQuantileRange,
                  min: min,
                  max: max
                })
              }, function (d) {
                return d.subgroup;
              })
              // Show the X scale
              let x = d3.scaleBand()
                  .range([0, width])
                  .domain(group)
                  .paddingInner(1)
                  .paddingOuter(.5)
              svgb.append("g")
                  .attr("transform", "translate(0," + height + ")")
                  .call(d3.axisBottom(x))

              // Show the Y scale
              let y = d3.scaleLinear()
                  .domain([0, plotDataDomain])
                  .range([height, 0])
              svgb.append("g").call(d3.axisLeft(y))


              // gridlines in y axis function
              function make_y_gridlines() {
                return d3.axisLeft(y)
                    .ticks(5)
              }

              // add the Y gridlines
              svgb.append("g")
                  .attr("class", "grid")
                  .attr("stroke", "currentColor")
                  .attr("stroke-opacity", 0.2)
                  .call(make_y_gridlines()
                      .tickSize(-width)
                      .tickFormat("")
                  )

              svgb.append("text")
                  .attr("text-anchor", "end")
                  .attr("x", width)
                  .attr("y", height + margin.top + 10)
                  .text("");

              svgb.append("text")
                  .attr("text-anchor", "end")
                  .attr("transform", "rotate(-90)")
                  .attr("y", -margin.left + 16)
                  .attr("x", -margin.top)
                  .style("font-size", "70%")
                  .text("%")

              // Show the main vertical line
              svgb
                  .selectAll("vertLines")
                  .data(sumstat)
                  .enter()
                  .append("line")
                  .attr("x1", function (d) {
                    return (x(d[0]))
                  })
                  .attr("x2", function (d) {
                    return (x(d[0]))
                  })
                  .attr("y1", function (d) {
                    return (y(d[1].min))
                  })
                  .attr("y2", function (d) {
                    return (y(d[1].max))
                  })
                  .attr("stroke", "black")
                  .style("width", 30)

              // rectangle for the main box
              let boxWidth = 180 / group.length
              svgb
                  .selectAll("boxes")
                  .data(sumstat)
                  .enter()
                  .append("rect")
                  .attr("x", function (d) {
                    return (x(d[0]) - boxWidth / 2)
                  })
                  .attr("y", function (d) {
                    return (y(d[1].q3))
                  })
                  .attr("height", function (d) {
                    return (y(d[1].q1) - y(d[1].q3))
                  })
                  .attr("width", boxWidth)
                  .attr("stroke", "black")
                  .style("fill", "#1FC8A4")
                  .on("mouseover", function (event, d) {
                    div.transition()
                        .duration(200)
                        .style("opacity", 0.9);
                    div.html(" min: " + roundDecimal(d[1].min, 3) + " <br>" + " max: " + roundDecimal(d[1].max, 3) + " <br> " + " median: " + roundDecimal(d[1].median, 3))
                        .style("background-color", 'orange')
                        .style("border-width", "3px")
                        .style("left", (event.pageX) + "px")
                        .style("top", (event.pageY - 100) + "px");

                  })
                  .on("mouseout", function (d) {
                    div.transition()
                        .duration(500)
                        .style("opacity", 0);
                  });
              // Show the median
              svgb
                  .selectAll("medianLines")
                  .data(sumstat)
                  .enter()
                  .append("line")
                  .attr("x1", function (d) {
                    return (x(d[0]) - boxWidth / 2)
                  })
                  .attr("x2", function (d) {
                    return (x(d[0]) + boxWidth / 2)
                  })
                  .attr("y1", function (d) {

                    return (y(d[1].median))
                  })
                  .attr("y2", function (d) {
                    return (y(d[1].median))
                  })
                  .attr("stroke", "black")
                  .style("width", 80)

              let jitterWidth = 80 / (group.length / 2)
              let circleRadius = 1

              svgb
                  .selectAll("indPoints")
                  .data(split.values)
                  .enter()
                  .append("circle")
                  .attr("cx", function (d) {
                    return (x(d.subgroup) - jitterWidth / 2 + Math.random() * jitterWidth)
                  })
                  .attr("cy", function (d) {
                    return (y(d.values))
                  })
                  .attr("r", circleRadius)
                  .style("fill", "white")
                  .attr("stroke", "black")

              if (legend) {

                svgb.append("text")
                    .attr('x', width / 2 - 15)
                    .attr('y', function (d, i) {
                      return (i * 12) + height + 30;
                    })
                    .text(split.group)
                    .attr('text-anchor', 'start')
                    .style("font-size", "15px")
                    .attr("alignment-baseline", "middle")
              }


              function roundDecimal(nombre, precision) {
                var precision = precision || 2;
                var tmp = Math.pow(10, precision);
                return Math.round(nombre * tmp) / tmp;
              }

            })
          } else {
            this.notEnoughData(margin, width, height)
          }
        }
      }
    }

  }
}
</script>

<style scoped>

</style>